export const PUBLIC_GRAPHQL_OPERATION_NAMES = new Set([
  'AcceptInvite',
  'GetInviteStatus',
  'GetTicketQrcode',
  'GetFormByLinkId',
  'SendMessages',
  'SendInvitationMessages',
  'createTickets',
  'UpdateTickets',
  'SubmitForm',
  'GetAuthQrcodeByUserId',
]);

export const PUBLIC_REST_PATHS = new Set(['/api/auth/logout', '/api/auth/refresh']);
